import React, { useEffect, useState } from "react";
import { fileUploadStyles } from "./fileUpload.styles";
import upload from "../../services/blobService";

const GooglePdfPreview = ({ url, height = '600px', width = '100%' }) => {
  if (!url) {
    return <p>No se proporcionó una URL válida para el PDF.</p>;
  }

  const googleViewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
    url
  )}&embedded=true`;

  return (
    <iframe
      src={googleViewerUrl}
      title="Vista previa del PDF"
      width={width}
      height={height}
      style={{ border: 'none' }}
      allowFullScreen
    />
  );
};

const FileUpload = ({
  name,
  register,
  accept = "application/pdf",
  label = "Seleccionar archivo",
  onChange,
  showPreview = true,
  previewHeight = "300px",
  error,
  existingFile = null,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  useEffect(() => {
    if (existingFile) {
      setSelectedFile(existingFile);
      if (typeof existingFile === 'string') {
        setPreviewUrl(existingFile);
      }
    }
  }, [existingFile]);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        setIsUploading(true);
        setUploadError(null);

        const uploadResult = await upload(file, (fileName, originalName) => {
          if (onChange) {
            onChange({
              path: fileName,
              originalName: originalName
            });
          }
        });

        if (uploadResult) {
          setSelectedFile({
            name: file.name,
            path: file.name
          });

          if (showPreview) {
            const fileUrl = URL.createObjectURL(file);
            setPreviewUrl(fileUrl);
          }
        } else {
          setUploadError("Error al subir el archivo");
        }
      } catch (err) {
        console.error("Error uploading file:", err);
        setUploadError("Error al subir el archivo");
      } finally {
        setIsUploading(false);
      }
    }
  };

  useEffect(() => {
    return () => {
      if (previewUrl && !existingFile) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl, existingFile]);

  const renderPreview = () => {
    if (!showPreview || !previewUrl) return null;

    if (previewUrl.includes('https://')) {
      return (
        <div style={fileUploadStyles.preview}>
          <GooglePdfPreview url={previewUrl} height={previewHeight} />
        </div>
      );
    }

    return (
      <div style={fileUploadStyles.preview}>
        <iframe
          src={previewUrl}
          title="File Preview"
          width="100%"
          height={previewHeight}
          style={{ border: 'none' }}
        />
      </div>
    );
  };

  return (
    <div style={fileUploadStyles.container}>
      <label style={fileUploadStyles.label}>
        <input
          type="file"
          accept={accept}
          {...register(name)}
          onChange={handleFileChange}
          style={{ display: "none" }}
          disabled={isUploading}
        />
        <div style={{
          ...fileUploadStyles.button,
          opacity: isUploading ? 0.7 : 1,
          cursor: isUploading ? 'not-allowed' : 'pointer'
        }}>
          {isUploading ? "Subiendo..." : selectedFile ? "Cambiar archivo" : label}
        </div>
      </label>
      
      {selectedFile && (
        <div style={fileUploadStyles.fileInfo}>
          <p>Archivo seleccionado: {selectedFile.name || existingFile}</p>
          {selectedFile.size && (
            <p>Tamaño: {(selectedFile.size / 1024 / 1024).toFixed(2)} MB</p>
          )}
        </div>
      )}

      {/* {renderPreview()} */}

      {(error || uploadError) && (
        <p style={fileUploadStyles.error}>{error || uploadError}</p>
      )}
    </div>
  );
};

export default FileUpload; 